var _style, _g, _g2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.7 280.1",
    style: {
      enableBackground: "new 0 0 212.7 280.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0094B1;}\r\n\t.st1{fill:#FDFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,140.4c0-35.7,0-71.3,0-107c0-21,12.3-33.3,33.2-33.3c31.5,0,63,0.1,94.4-0.1c9.7-0.1,17.8,3.1,24.8,9.8 c16.3,15.7,32.7,31.3,49.3,46.8c7.5,7.1,11.1,15.5,11,25.8c-0.1,55.1,0,110.3,0,165.4c0,19.6-12.6,32.3-32.2,32.3 c-49.5,0-98.9,0-148.4,0c-19.2,0-32-12.7-32.1-31.9C0,212.3,0,176.3,0,140.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.9,186.2c10.6,12.8,20.5,24.7,30.9,37.3c14.5-18.7,28.7-37,43.4-56c18.6,24.8,36.7,49.1,55.6,74.2 c-58,0-114.8,0-173,0C34.3,223.1,48.3,205,62.9,186.2z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 148.9,
    cy: 106.1,
    r: 26.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.e906cfc313bf19cd809b40db71d15493.svg";
export { ForwardRef as ReactComponent };